import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import * as _ from 'lodash';
import { ItemService } from "../services";

@Component({
    selector: 'tag-picker',
    styles: [`
        .mat-chip.mat-standard-chip.keyTag.disabledSet {
            background-color: gray; 
            opacity: .8;
        }

        .force-full-width {
            min-width: 100%;
            width: 100%;
        }
    `],
    template: `
        <mat-card  *ngIf="availableTags && availableTags.length" fxFlex="100" style="margin: 15px;" class="force-full-width">
            <mat-card-title>
                <h4 fxFlex="nogrow">Select tags from below to refine your topic.</h4>
                <mat-icon color="primary" 
                          [matTooltip]="helpText" 
                          matTooltipClass="info-tooltip" 
                          matTooltipPosition="after" 
                          style="margin-left: 10px; margin-top: 30px;">info</mat-icon>
            </mat-card-title>
            <mat-card-content>
                <mat-chip-list [selectable]="!disabled" fxFlex="100" class="force-full-width">
                    <mat-chip *ngFor="let tag of filterdTags" (click)="addTag(tag)" [ngClass]="tagDefs[tag.type].cls" [selectable]="!disabled">
                        <span style="padding: 5px;" [ngStyle]="{ 'font-size': tagFontSize(tag) }">{{tagLabel(tag)}}</span>
                        <small class="text-muted">({{tag.doc_count}})</small>
                    </mat-chip>
                </mat-chip-list>
            </mat-card-content>
            <mat-card-actions>
                <div style="padding-top: 20px; padding-bottom: 5px;"><mat-label>Pick types to hide or show</mat-label></div>
                <mat-chip-list>
                    <mat-chip *ngFor="let key of keyTags" 
                            [ngClass]="classFor(key)"
                            (click)="tagDefs[key].disabled = !tagDefs[key].disabled">
                        {{tagDefs[key].label}}
                    </mat-chip>
                </mat-chip-list>
            </mat-card-actions>
        </mat-card>
    `
})
export class TagPickerComponent {
    @Input() basicFilterStructure: FormArray;
    @Input() availableTags: any[];
    @Input() keyTags: any[];
    @Input() docCount: number;
    @Input() disabled: boolean;
    @Output() onSelect = new EventEmitter();
    helpText = 'Tags are generated from content that matches your keywords. Selecting tags adds the associated content to your topic. You can choose to include or exclude tags in order to precisely control your topic through tag groups.';
    tagDefs;

    constructor(private fb: FormBuilder, itemService: ItemService) {
        this.tagDefs = itemService.tagDefs;
    }

    get filterdTags(): any[] {
        const tagValues = (<FormArray>this.basicFilterStructure.get('values')).controls.map(ctrl => ctrl.get('key').value);
        return _.filter(this.availableTags, tag => !_.includes(tagValues, tag.key) && !this.tagDefs[tag.type].disabled);
    }

    tagLabel(tag): string {
        return tag ? _.replace(tag.key, /_/g, ' ') : '';
    }

    tagFontSize(tag): string {
        const tagPercentage = (tag.doc_count * 100)  / this.docCount
        if (tagPercentage < 0.333) {
            return '1.09em'; 
        } else if (tagPercentage < 0.666) {
            return '1.59em';
        } else {
            return '2.09em';
        }
    }

    addTag(tag): void {
        if (!this.disabled) {
            const tagCtrl: FormGroup = this.fb.group({ 
                key: [''],
                tagText: [''], 
                doc_count: [''], 
                type: ['']});
            tagCtrl.setValue(_.extend({}, tag, { tagText: tag.key }));
            (<FormArray>this.basicFilterStructure.get('values')).push(tagCtrl);
            this.onSelect.emit();
        }
    }

    classFor(key) {
        let ret = { disabledSet: this.tagDefs[key].disabled, keyTag: true };
        ret[this.tagDefs[key].cls] = true;
        return ret;
    }
}